module.exports = __webpack_public_path__ + "img/sandClock.2c9183b7.svg";